export default "__VITE_ASSET__DUoKImmE__"